export const DEBUG = import.meta.env.VITE_DEBUG === 'true'

export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  },
  baseUrl: import.meta.env.VITE_BASE_URL,
  debug: DEBUG,
}

// Get the base URL for generating portal links
export function getBaseUrl(): string {
  // Use BASE_URL environment variable if set
  if (config.baseUrl && config.baseUrl.trim() !== '') {
    return config.baseUrl.trim()
  }
  
  // Fallback to current window origin for development
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  
  // Development fallback
  return 'http://localhost:5173'
}
// Validate required environment variables
export function validateEnvironment(): { isValid: boolean; missingVars: string[] } {
  const requiredVars = [
    { key: 'VITE_SUPABASE_URL', value: config.supabase.url },
    { key: 'VITE_SUPABASE_ANON_KEY', value: config.supabase.anonKey },
  ]

  const missingVars = requiredVars
    .filter(({ value }) => !value || value.trim() === '')
    .map(({ key }) => key)

  // Additional validation for URL format
  if (config.supabase.url && !config.supabase.url.includes('supabase.co') && !config.supabase.url.includes('localhost')) {
    console.warn('Supabase URL format may be incorrect:', config.supabase.url)
  }

  return {
    isValid: missingVars.length === 0,
    missingVars,
  }
}